<main id="login-page">
    <div class="main-panel">
        <div class="row">
            <div class="col-md-7 col-sm-12 margin-bottom-20" >
                <h3>Account Settings</h3>
                <form *ngIf="accountSettings" id="accountForm" (ngSubmit)="doSaveAccountSettings(accountForm)" #accountForm="ngForm">
                    <div class="row">
                        <div class="col-sm-3 col-xs-12 margin-top-20">
                            First Name:
                        </div>
                        <div class="col-sm-9 col-xs-12">
                            <input class="form-control"  ngModel id="FirstName" name="firstName" required email placeholder="First Name" type="text" value="{{accountSettings.FirstName}}">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-xs-12 margin-top-20">
                            Last Name:
                        </div>
                        <div class="col-sm-9 col-xs-12">
                            <input class="form-control"  ngModel id="LastName" name="lastName" required placeholder="Last Name" type="text" value="{{accountSettings.LastName}}">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3 col-xs-12 margin-top-20">
                            Email:
                        </div>
                        <div class="col-sm-9 col-xs-12">
                            <input class="form-control"  ngModel id="Email" name="email" required placeholder="Email" type="text" value="{{accountSettings.EmailAddress}}">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <button class="btn btn-block" type="submit">Save Settings</button>
                        </div>
                    </div>                                                       
                </form>
            </div>
            <div class="col-md-5 col-sm-12 margin-bottom-20">
                <h3>Change Password</h3>
                <form id="passwordForm" (ngSubmit)="changePassword(passwordForm)" #passwordForm="ngForm">
                    <input class="form-control"  ngModel id="password" name="password" required email placeholder="New Password" type="password" value="">                                
                    <input class="form-control"  ngModel id="confirmPassword" name="confirmPassword" required placeholder="Confirm New Password" type="password" value="">
                    <button class="btn btn-block" type="submit">Update Password</button>
                </form>
            </div>
        </div> 
        <div class="row margin-top-10">
            <div class="col-md-12">
                <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#myModal">
                    Close Account
                </button>

                <div class="modal" id="myModal">
                    <div class="modal-dialog">
                        <div class="modal-content">
                        
                            <!-- Modal Header -->
                            <div class="modal-header">
                                <h4 class="modal-title">Close Account</h4>
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                            </div>
                            
                            <!-- Modal body -->
                            <div class="modal-body">
                                    Sorry to hear you want to close your account.<br/>
                                    Please note that you will you will lose the ability to earn digital badges<br/>
                                    <br/><br/>
                                    Are you really sure you want to continue?
                            </div>
                            
                            <!-- Modal footer -->
                            <div class="modal-footer">
                                <button type="button" class="btn btn-danger" (click)="cancelAccount()" data-dismiss="modal">Ok</button>
                                <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</main>